import { useRef, useEffect, useState } from "react";
import { IcCardGreen, IcCardOrange, IcCardYellow, IcSecondpageBgWeb, IosG1cashHomePhone } from "../../constants/icons";
import IosG1cashHistorySrc from "../../assets/images/ios-g1cash-history.png";
import IcCardGreenSrc from "../../assets/images/icon/ic-card-green.png";
import "./secondpage.css";

const SecondPage = () => {
    const secondPageRef = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        //for interaction
        const observer = new IntersectionObserver(
            (entries) => {
                entries.map((entry) => {
                    if (entry.isIntersecting && !entry.target.classList.contains("show")) {
                        setShow(true);
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(secondPageRef.current);
    }, []);

    return (
        <div className={`${show ? "show" : ""} second-page`} ref={secondPageRef}>
            <div className="second-page-top">
                <div className="second-title title">
                    {"Start "}
                    <span>Spending</span>
                    {" and\n"}
                    <span>investing</span>
                    {" smarter today!"}
                </div>
                <div className="second-subtitle subtitle">
                    {"Maximize your purchasing power and watch your investments grow.\nTake control of your financial future with G1CASH."}
                </div>
            </div>

            <div className="second-page-bottom">
                <IcSecondpageBgWeb className="second-page-bg-web" />

                <IosG1cashHomePhone className="second-page-phone" />
                <img src={IosG1cashHistorySrc} className="second-page-history" />

                <div className="second-page-cards">
                    <IcCardYellow className="second-page-yellow-card" />
                    <IcCardOrange className="second-page-orange-card" />
                    {/* <img src={IcCardGreenSrc} className="second-page-green-card" /> */}
                    <IcCardGreen className="second-page-green-card" />
                </div>
            </div>
        </div>
    );
};

export default SecondPage;
